import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: ['M7 10l4-4v8zM12 6h1v8h-1V6z'],
  height: 20,
  width: 20,
});
